module.exports = __webpack_public_path__ + "media/images/recruit/common/android-chrome-192x192-5931955bba087320f1230744c8ad5220.png";